import { useEffect, useState } from "react";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";

export function useDashboardContext() {
  const { user } = useAuth();
  // BusinessProvider already loaded (and handles errors for) the selected business and location.
  const { businessId = "", locationId = "", business, location } = useCurrentBusiness();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const update = () => setNow(new Date());
    const timer = window.setInterval(update, 15_000);
    window.addEventListener("focus", update);
    document.addEventListener("visibilitychange", update);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, []);

  return { user, businessId, locationId, business, location, now };
}
